<template>
  <div class="main-guide-area">
    <!-- <div class="tit-h5 pdb-6">{{ t('label_user_guide') }}</div> -->
    <article class="guide-card">
      <div class="banner-item banner-left">
        <div class="banner-txt-wrap">
          <div class="logo mb-2">
            <img :src="getAssetImageUrl('common/logos/logo-sconchat-full.png')" alt="Logo" class="logo" />
          </div>
          <h1 class="tit-h1">
            {{ t('label_sconchat_guide') }}
          </h1>
        </div>
        <button class="white-btn l-btn" type="button" @click.prevent="handleManualRedirect">
          {{ t('label_move_guide') }}
        </button>
      </div>
      <div class="banner-item banner-object">
        <img :src="getAssetImageUrl('self-service/deco/guide.svg')" alt="" />
      </div>
    </article>
  </div>
</template>

<script setup lang="ts">
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';
import { useGtag } from '@/composables/shared/useGtag';
import { useUserStore } from '@/stores/user';
import redirectToManualPage from '@/utils/redirectToManualPage';

const { t } = useI18n();

const userStore = useUserStore();

const { trackEventClick } = useGtag();

const manualLanguage = computed<'ko' | 'en'>(() => {
  return userStore.pageLanguage === 'ko' ? 'ko' : 'en';
});

const handleManualRedirect = () => {
  trackEventClick('main', '이용가이드 배너');
  redirectToManualPage(manualLanguage.value);
};
</script>

<style scoped lang="scss">
.main-guide-area {
  padding: 0 0 80px;
}
.guide-card {
  width: 100%;
  padding: 70px 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(0deg, rgba(216, 221, 255, 1) 0%, rgba(240, 247, 255, 1) 100%);
  border-radius: 1.25rem;
  .banner-item {
    .banner-txt-wrap {
      .logo {
        width: 128px;
        img {
          width: 100%;
          object-fit: contain;
        }
      }
      .tit-h1 {
        white-space: pre-wrap;
        margin-bottom: 2.5rem;
        line-height: 120%;
      }
    }
    .white-btn {
      width: auto;
      background: #fff;
      padding: 0 1.25rem;
      font-weight: 600;
    }
  }
}

@include respond-to(tablet) {
  .main-guide-area {
    padding: 0 0 60px;
    .guide-card {
      padding: 40px;
      .banner-item {
        .banner-txt-wrap {
          .tit-h1 {
            font-size: 2rem;
          }
        }
      }
    }
  }
}
@media (max-width: 640px) {
  .main-guide-area {
    padding: 0 0 40px;
    .guide-card {
      padding: 40px;
      flex-direction: column;
      gap: 1.5rem;
      .banner-item {
        text-align: center;
        .banner-txt-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          .tit-h1 {
            text-align: center;
            font-size: 1.75rem;
            margin-bottom: 1.5rem;
          }
        }
      }
    }
  }
}
</style>
